import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ListResponse } from '@ca/core/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModuleCategoryV1Read } from '../models/module-category-v1-read.model';
import { DataService } from './abstract-services/data.service';

@Injectable()
export class ModuleCategoriesV1Service extends DataService<ModuleCategoryV1Read> {
    apiUrl = 'module_manager/v1/public/modulecategories';

    constructor(protected http: HttpClient) {
        super();
    }

    getCategories(): Observable<ModuleCategoryV1Read[]> {
        return this.http
            .get('/api/module_manager/v1/public/modulecategories', { headers: { 'Content-Type': 'application/query.api+json' } })
            .pipe(map((res: ListResponse<ModuleCategoryV1Read>) => res.data));
    }

    protected createNewInstance(): ModuleCategoryV1Read {
        return new ModuleCategoryV1Read();
    }
}
